import React, {Component, Fragment} from "react";
import {Button, FormGroup, Input, Label} from "reactstrap";
import {dateHelper, getFormFieldValue} from "../../Applications/shared/shared";
import {postData} from "../../../api/doLogin";

export default class NotesTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: "",
      showAdd: false,
    }
  }

  setAddMode(on) {
    this.setState({showAdd: on, note: ""}, () => this.props.onAddMode && this.props.onAddMode(on));
  }

  saveNote() {
    const self = this;
    postData(`${this.props.noteType || "lms"}/${this.props.lmsId || 0}/note/add`, {note: this.state.note}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.onUpdate(data.data);
          self.setAddMode(false);
        } else {
          console.error(error);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  onUpdate(note) {
    let found = false;
    let notes = this.props.notes.map((not) => {
      if (note.id === not.id) {
        found = true;
        return note;
      } else {
        return not;
      }
    });
    if (!found) {
      notes = [note, ...notes];
    }
    this.props.onUpdate && this.props.onUpdate(notes);
  }

  render() {
    return <Fragment>
      {!!this.state.showAdd ?
        <div>
          <FormGroup className={"form-group-condensed"}>
            <Label for="note">Note</Label>
            <Input
              type="textarea"
              id="note"
              rows={10}
              autoFocus
              value={getFormFieldValue(this.state.note)}
              onChange={(evt) => this.setState({note: evt.target.value})}
            />
          </FormGroup>
          <div>
            <Button color={"primary"}
                    onClick={() => this.saveNote()}>Add</Button>
            <Button color={"secondary"}
                    onClick={() => this.setAddMode(false)}>Cancel</Button>
          </div>
        </div>
        :
        <Fragment>
          <div><Button className={"primary"}
                       onClick={() => this.setAddMode(true)}>Add</Button></div>
          <div style={{overflowY: "auto", maxHeight: 600, overflowWrap: "anywhere"}}>
            <table cellSpacing={5} cellPadding={5}>
              <thead>
              <tr>
                <td style={{width: "15%"}}>User / Date</td>
                <td style={{width: "85%"}}>Comment</td>
              </tr>
              </thead>
              <tbody>
              {this.props.notes && this.props.notes.map((note, index) => {

                return <tr key={index} style={{paddingBottom: 10, borderBottom: "1px solid black"}}>
                  <td style={{verticalAlign: "top"}}>
                    {!note.FName && !note.LName ? "System User" : `${note.FName} ${note.LName}`}
                    <br/>
                    {dateHelper(new Date(note.date_time))}
                  </td>
                  <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>{note.notes}</td>
                </tr>
              })}
              </tbody>
            </table>
          </div>
        </Fragment>
      }
    </Fragment>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Leads/views/NotesTab.js